/*
  🦾 Custom splide by BoostEcom
  ➕ Splide carousel wrapper avec defaults BoostEcom
  🔒 Ne pas toucher — Chargé globalement pour tous les blocs carousel
  ⚠️ Mise à jour effectuée le 20 mars 2026 par @Christopher Lasgi

  Problème : Splide CDN lourd (~30KB), chargé plusieurs fois par bloc.
  Solution : Wrapper centralisé qui charge le CDN on-demand et initialise avec les defaults.

  Import : <script src="{{ 'custom-splide_boostecom.js' | asset_url }}" defer></script>
  Dépendances : Splide.js (CDN chargé on-demand), custom-utils_boostecom.js
*/

window.BoostEcom = window.BoostEcom || {};

/* ───────────────────────────────────────────────
   Splide CDN URLs
   ─────────────────────────────────────────────── */

BoostEcom.SPLIDE_CSS = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4/dist/css/splide.min.css';
BoostEcom.SPLIDE_JS = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4/dist/js/splide.min.js';

/* ───────────────────────────────────────────────
   1. Ensure Splide is loaded
   ─────────────────────────────────────────────── */

/**
 * Load Splide CSS if not already present.
 */
BoostEcom.loadSplideCSS = function () {
  if (document.querySelector('link[href*="splide"]')) return;
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = BoostEcom.SPLIDE_CSS;
  document.head.appendChild(link);
};

/**
 * Load Splide JS if not already present.
 * @param {Function} callback - Called when Splide is ready.
 */
BoostEcom.loadSplideJS = function (callback) {
  if (typeof Splide !== 'undefined') {
    if (callback) callback();
    return;
  }

  if (document.querySelector('script[src*="splide"]')) {
    // Script tag exists but Splide not yet available — wait
    BoostEcom._waitForSplide(callback);
    return;
  }

  var script = document.createElement('script');
  script.src = BoostEcom.SPLIDE_JS;
  script.defer = true;
  script.onload = function () {
    if (callback) callback();
  };
  document.head.appendChild(script);
};

/**
 * Wait for Splide global to become available (retry up to 80 × 150ms = 12s).
 * @param {Function} callback
 * @private
 */
BoostEcom._waitForSplide = function (callback) {
  var attempts = 0;
  var interval = setInterval(function () {
    attempts += 1;
    if (typeof Splide !== 'undefined') {
      clearInterval(interval);
      if (callback) callback();
    } else if (attempts > 80) {
      clearInterval(interval);
    }
  }, 150);
};

/* ───────────────────────────────────────────────
   2. Initialize Splide with BoostEcom defaults
   ─────────────────────────────────────────────── */

/**
 * Default Splide config for BoostEcom carousels.
 * @param {HTMLElement} el - The .splide element (reads --gap CSS variable)
 * @returns {Object} Splide options
 */
BoostEcom.splideDefaults = function (el) {
  var GAP = el ? getComputedStyle(el).getPropertyValue('--gap').trim() || '16px' : '16px';

  return {
    type: 'loop',
    autoplay: false,
    interval: 3000,
    pauseOnHover: true,
    pauseOnFocus: true,
    autoHeight: true,
    perPage: 1,
    perMove: 1,
    gap: GAP,
    arrows: false,
    pagination: true,
    drag: true,
    wheel: true,
    snap: true,
    flickPower: 100,
    dragMinThreshold: 10,
    keyboard: 'global',
    waitForTransition: true,
    trimSpace: true,
    resetProgress: true,
    focus: 0,
    padding: {
      left: '0',
      right: 'calc(50% - (' + GAP + ' / 2))'
    },
    mediaQuery: 'min',
    breakpoints: {
      480: { gap: GAP },
      640: { gap: GAP },
      768: { gap: GAP },
      1024: {
        destroy: true,
        perPage: 4,
        gap: GAP
      }
    }
  };
};

/**
 * Initialize a Splide carousel on an element.
 * Loads Splide from CDN if not present, prevents double-init.
 * @param {HTMLElement} el - The .splide element
 * @param {Object} [overrides] - Custom Splide options to merge with defaults
 * @param {Function} [callback] - Called after mount with the Splide instance
 */
BoostEcom.initSplide = function (el, overrides, callback) {
  if (!el) return;
  if (el.dataset.splideInitialized === 'true') {
    if (callback) callback(null);
    return;
  }

  BoostEcom.loadSplideCSS();

  BoostEcom.loadSplideJS(function () {
    var defaults = BoostEcom.splideDefaults(el);
    var options = Object.assign({}, defaults, overrides || {});

    // Merge nested breakpoints
    if (overrides && overrides.breakpoints) {
      options.breakpoints = Object.assign({}, defaults.breakpoints, overrides.breakpoints);
    }

    var splide = new Splide(el, options);
    splide.mount();
    el.dataset.splideInitialized = 'true';

    if (callback) callback(splide);
  });
};

/*
  © 2026 CustomSplide. Tous droits réservés.
  Créé avec ❤️ par Christopher Lasgi pour les développeurs Shopify (OS 3.0).

  Mais ATTENTION :

  ⚠️ Pas pour les curieux. Ici on bosse.

  Tous les livrables dans ce service sont des créations originales protégées par l'écosystème « BoostEcom » (art. L111‑1 et suivants du Code de la propriété intellectuelle).

  En achetant mes services, tu obtiens une licence d'utilisation NON‑exclusive, NON‑transférable et NON‑cessionnable :

  ✔️ Usage illimité sur ta (tes) boutique(s) Shopify.
  ❌ Interdiction de revendre, copier, republier ou distribuer tout ou partie de ces livrables, même modifiés.
  ❌ Interdiction de créer un service "clone" ou d'en réutiliser la description (Shopify bannit la duplication).

  **Tout manquement déclenchera :**

  1. Plainte DMCA / retrait Shopify, conformément aux CGU (section 6, "contenu original").
  2. Facturation immédiate d'une pénalité équivalente à 3× le prix public.
  3. Action judiciaire en contrefaçon si nécessaire.
  4. Et l'envoi d'une armée de méchants robots à ta poursuite… (je plaisante 😅).

  Merci de respecter mon travail, créons plutôt ensemble des écosystèmes e‑commerce qui cartonnent ! ✌️
*/
